import React from 'react';
import { Link } from 'react-router-dom';


class Footer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			
		}
	}
		
	componentDidMount() {		
	
	}
		
	render() {
		
		if(localStorage.getItem('schoolData')) {
			return (
			<>
		
			</>
		)
		}
		else{
			return (
			<>
		 
			
		 
			</>
		)
		}
		
	  
	}
}
export default Footer;
